import { Api, ApiResponse } from './api';

/**
 * Used by the frontend form class to send form data
 */
export class FormApi {
    constructor(public readonly url: string, private readonly api: typeof Api) {}

    async send(form: string, data: Record<string, unknown>): Promise<ApiResponse> {
        return this.api.api_post(`${this.url}/api/form/${form}`, data);
    }
}
